import MainPracticeScenario from './MainPracticeScenario';
import { constants, Globals } from '../../../../misc/helpers';
import { ScenarioEndType } from '../../../../misc/BleedingControlScenario';

export default class MainPracticeScenarioSteps5And6 {
	constructor(private mainScenario: MainPracticeScenario, private onDone: () => void, public showFailedAar: () => void) {
	}

	start() {
		this.step1ApplyPressure();
	}

	private step1ApplyPressure() {
		var context = this;
		Globals.stopTimer = false;
		this.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.BleedoutTimer, {
			dispatch: this.mainScenario.gameManager.customData.dispatch,
			onTimeRanOut: () => {
				this.showFailedAar();
			},
			isActive: true
		});
		context.mainScenario.playSound('Step-3', '1', () => {
			this.mainScenario.playSound('Step-4', '1', () => {
			context.mainScenario.playSequence('VictimPlayLips');
			this.mainScenario.playSound('Step-4', '2', () => {
				context.mainScenario.playSequence('VictimStopLips');
			});
			});
		});
		this.mainScenario.playSequence('ApplyPressureSetup', null, ()=> {
			var isPlaying = false;
			
			//data start
			var setData = {
				disabled: false,
				dispatch: context.mainScenario.gameManager.customData.dispatch,
				onTapAndHold: () => {
						context.mainScenario.playSequence('SetBloodParticlePercentage', {
							zeroPercent: true,
							twentyFivePercent: false,
							fiftyPercent: false,
							seventyFivePercent: false,
							oneHundredPercent: true
						});
					if(!isPlaying) {
						setTimeout(() => {
							context.mainScenario.playSequence('VictimPlayLips');
							this.mainScenario.playSound('Step-5', '1', () => {
								this.mainScenario.playSound('Step-5', '2', () => {
									context.mainScenario.playSequence('VictimStopLips');
									this.mainScenario.playSound('Step-5', '3', () => {
										this.mainScenario.playSound('Step-6', '1', () => {
											context.mainScenario.playSequence('VictimPlayLips');
											this.mainScenario.playSound('Step-6', '2', () => {
												context.mainScenario.playSequence('VictimStopLips');
											});
										});
									});
								});
							});
						}, 2000);
			
					}

					isPlaying = true;
				},
				onReleased: () => {
					setData.disabled = true;
				context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.ApplyPressure, setData);
				setTimeout(() => {
					setTimeout(() => {
						setData.disabled = false;
						context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.ApplyPressure, setData);
					}, 2000)
					context.mainScenario.playSequence('SetBloodParticlePercentage', {
						zeroPercent: false,
						twentyFivePercent: false,
						fiftyPercent: false,
						seventyFivePercent: false,
						oneHundredPercent: true
					});
				}, 3000)
			},
				onDone: () => {
					setData.disabled = true;
					context.step2HasBleedingStoppedAudio()
					context.mainScenario.playSequence('SetBloodParticlePercentage', {
						zeroPercent: true,
						twentyFivePercent: false,
						fiftyPercent: false,
						seventyFivePercent: false,
						oneHundredPercent: false
					});
				}
			};
			//data end
			context.mainScenario.gameManager.UiManager.hideaAllUis();
			context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.ApplyPressure, setData);
			context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.Feedback, {message: 'Apply pressure by tapping and holding the tap & hold button. KB: Highlight button, then press and hold the Alt + Z keys.'});
			});
	}

	private step2HasBleedingStoppedAudio() {
		var context = this;
		this.mainScenario.aarApplyPressureWithPD = true;
		if(this.mainScenario.endAt === ScenarioEndType.pressureDressing) {
			Globals.stopTimer = true;
			context.mainScenario.stopBleeding();
		}
		context.mainScenario.gameManager.UiManager.hideUi(constants.InGameUINames.ApplyPressure);

			if(this.mainScenario.endAt === ScenarioEndType.pressureDressing) {
				context.step2HasBleedingStoppedScenarioA();
			}
			else context.step2HasBleedingStopped();

	}

	private step2HasBleedingStopped() {
		var context = this;

				context.mainScenario.gameManager.UiManager.showSingleUi(constants.InGameUINames.BinaryQuestion, {
					title: 'Has the bleeding stopped?',
					correctButton: {
						title: 'Yes',
						onClick: () => context.step2HasBleedingStoppedIncorrect()
					},
					incorrectButton: {
						title: 'No',
						onClick: () => context.mainScenario.onAnsweredCorrectly('MainPracticeScenarioSteps5And6.step2HasBleedingStopped', () => {
							context.step2HasBleedingStoppedCorrect();
						})
					}
				});
				context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.LookAtObject, {
					dispatch: context.mainScenario.gameManager.customData.dispatch
		});
	}

	private step2HasBleedingStoppedScenarioA() {
		var context = this;
				context.mainScenario.gameManager.UiManager.showSingleUi(constants.InGameUINames.BinaryQuestion, {
					title: 'Has the bleeding stopped?',
					correctButton: {
						title: 'Yes',
						onClick: () => context.mainScenario.onAnsweredCorrectly('MainPracticeScenarioSteps5And6.step2HasBleedingStopped', () => {
							context.step2HasBleedingStoppedCorrect();
						})
					},
					incorrectButton: {
						title: 'No',
						onClick: () => context.step2HasBleedingStoppedIncorrect()
					}
				});
				context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.LookAtObject, {
					dispatch: context.mainScenario.gameManager.customData.dispatch
		});
	}

	private step2HasBleedingStoppedIncorrect() {
		var context = this;
		context.mainScenario.gameManager.UiManager.hideaAllUis();
		if(context.mainScenario.endAt === ScenarioEndType.pressureDressing) {
			this.mainScenario.showJITFeedback('This choice is incorrect', () => context.step2HasBleedingStoppedScenarioA());
		}
		else {
			this.mainScenario.showJITFeedback('This choice is incorrect', () => context.step2HasBleedingStopped());
		}
	}

	private step2HasBleedingStoppedCorrect() {
		var context = this;
		this.mainScenario.aarReassessAfterPD = true;
		context.mainScenario.gameManager.UiManager.hideaAllUis();
		this.mainScenario.playSound('Step-7', '1', () => {
			context.mainScenario.playSequence('VictimPlayLips');
			this.mainScenario.playSound('Step-7', '2', () => {
				context.mainScenario.playSequence('VictimStopLips');
				context.step3RemovePressureDressing();
		});
	});
	}

	private step3RemovePressureDressing() {
		var context = this;

		context.mainScenario.gameManager.UiManager.showSingleUi(constants.InGameUINames.BinaryQuestion, {
			title: 'Do you want to remove the pressure dressing?',
			correctButton: {
				title: 'Yes',
				// onClick: context.mainScenario.endAt === ScenarioEndType.pressureDressing ? () => context.mainScenario.onAnsweredCorrectly('MainPracticeScenarioSteps5And6.step3RemovePressureDressing', () => {
				// 	context.step3RemovePressureDressingCorrect();
				// }) : () => context.step3RemovePressureDressingIncorrect()
				onClick: () => context.step3RemovePressureDressingIncorrect()
			},
			incorrectButton: {
				title: 'No',
				// onClick: context.mainScenario.endAt === ScenarioEndType.pressureDressing ? () => context.step3RemovePressureDressingIncorrect() : () => context.mainScenario.onAnsweredCorrectly('MainPracticeScenarioSteps5And6.step3RemovePressureDressing', () => {
				// 	context.step3RemovePressureDressingCorrect();
				// })
				onClick: () => context.mainScenario.onAnsweredCorrectly('MainPracticeScenarioSteps5And6.step3RemovePressureDressing', () => {
					context.step3RemovePressureDressingCorrect();
				})
			}
		});
	}

	private step3RemovePressureDressingIncorrect() {
		var context = this;
		context.mainScenario.gameManager.UiManager.hideaAllUis();
		this.mainScenario.showJITFeedback('This choice is incorrect', () => context.step3RemovePressureDressing());
	}

	private step3RemovePressureDressingCorrect() {
		this.mainScenario.aarPressureDressingNotRemoved = true;
		this.mainScenario.playSequence('EnablePressureInVictim');
		this.mainScenario.playSequence('SetBloodParticlePercentage', {
			zeroPercent: true,
			twentyFivePercent: false,
			fiftyPercent: false,
			seventyFivePercent: false,
			oneHundredPercent: false
		});
		this.mainScenario.gameManager.UiManager.hideaAllUis();
		this.onDone();
	}
}